import { useState } from 'react';
import './styles.css';
import { BreadCrumb } from 'primereact/breadcrumb';
import { Button } from 'primereact/button';
import 'react-tabs/style/react-tabs.css';
import { InputText } from 'primereact/inputtext';
import api from 'src/services/api';

export default function CadastroClientes(props) {
  const [nomeCliente, setNomeCliente] = useState('');

  const breadcrumbItems = [
    { label: 'Configurações', url: '/configuraçoes' },
    { label: 'Clientes', url: '/clientes' },
    { label: 'Cadastro de Clientes', url: '/clientes' },
  ];

  const handleCriarCliente = async () => {
    try {
      const response = await api.post('/api/clientes', {
        nomeCliente: nomeCliente,
      });

      if (response.data) {
        alert('Cliente criado com sucesso!');
      } else {
        alert('Erro ao criar cliente. Por favor, tente novamente.');
      }
    } catch (error) {
      console.error('Erro:', error);
      alert(
        'Ocorreu um erro ao criar o cliente. Por favor, tente novamente mais tarde.',
      );
    }
  };

  return (
    <div
      style={{
        width: '100vw',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <BreadCrumb
        model={breadcrumbItems}
        home={{ label: 'Home', url: '/' }}
        style={{
          marginTop: '-33px',
          marginRight: '600px',
          border: 'none',
          color: '#B7D400!important',
        }}
      />

      <p
        style={{
          fontSize: '35px',
          fontStyle: 'normal',
          fontWeight: '700',
          color: '#006998',
          marginTop: '-15px',
        }}
      >
        Cadastro de Cliente
      </p>
      <div
        style={{ width: '1000px', display: 'flex', justifyContent: 'center' }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="1372"
          height="10"
          viewBox="0 0 1372 10"
          fill="none"
        >
          <g filter="url(#filter0_d_110_89)">
            <path
              d="M4 1L1368 1.00012"
              stroke="#006998"
              stroke-opacity="0.55"
              stroke-width="2"
              shape-rendering="crispEdges"
            />
          </g>
          <defs>
            <filter
              id="filter0_d_110_89"
              x="0"
              y="0"
              width="1372"
              height="10"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="4" />
              <feGaussianBlur stdDeviation="2" />
              <feComposite in2="hardAlpha" operator="out" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.521615 0 0 0 0 0.521615 0 0 0 0 0.521615 0 0 0 0.15 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow_110_89"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow_110_89"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      </div>
      <fieldset
        style={{
          width: '800px',
          minHeight: '250px',
          height: '300px',
          border: '1px solid #006998',
          marginTop: '35px',
          fontWeight: 'bold',
          borderRadius: '8px',
        }}
      >
        <div style={{ display: 'flex', marginTop: '10px' }}>
          <p style={{ marginTop: '10px', fontWeight: '400' }}>
            Nome de cliente
          </p>
        </div>
        <legend style={{ fontSize: '20px', fontWeight: 400, color: 'black' }}>
          Informações do Cliente
        </legend>
        <InputText
          style={{
            width: '80%',
            display: 'flex',
            marginTop: '-10px',
            borderColor: '#006998',
            fontStyle: 'italic',
          }}
          placeholder="Insira aqui o nome do cliente"
          value={nomeCliente}
          onChange={(e) => setNomeCliente(e.target.value)}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            marginTop: '30px',
          }}
        >
          <Button
            label="Cancelar"
            className="p-button-outlined p-button-primary"
            style={{ marginLeft: '10px', color: 'red' }}
          />

          <Button
            label="Criar"
            className="p-button-outlined p-button-primary"
            style={{
              marginLeft: '10px',
              color: '#FFF',
              backgroundColor: '#3900DB',
            }}
            onClick={handleCriarCliente}
          />
        </div>
      </fieldset>
    </div>
  );
}
